export default function SocialConnectionsIcon() {
   return (
      <svg
         width="45"
         height="45"
         viewBox="0 0 45 45"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <mask
            id="mask0_5451_24667"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="45"
            height="45"
         >
            <path
               d="M44.6642 0.733185H0.617188V44.7802H44.6642V0.733185Z"
               fill="white"
            />
         </mask>
         <g mask="url(#mask0_5451_24667)">
            <path
               d="M22.6408 15.8458C24.9291 15.8458 26.7874 17.7043 26.7874 19.9924C26.7874 22.2815 24.9291 24.139 22.6408 24.139C20.3525 24.139 18.4941 22.2815 18.4941 19.9924C18.4941 17.7043 20.3525 15.8458 22.6408 15.8458Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M22.641 10.3169C29.5064 10.3169 35.0808 15.8914 35.0808 22.7568C35.0808 29.6229 29.5064 35.1965 22.641 35.1965C15.7755 35.1965 10.2012 29.6229 10.2012 22.7568C10.2012 15.8914 15.7755 10.3169 22.641 10.3169Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.05288 2.02365C8.34107 2.02365 10.1995 3.8821 10.1995 6.17029C10.1995 8.45927 8.34107 10.3169 6.05288 10.3169C3.76458 10.3169 1.90625 8.45927 1.90625 6.17029C1.90625 3.8821 3.76458 2.02365 6.05288 2.02365Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.05288 43.4898C8.34107 43.4898 10.1995 41.6321 10.1995 39.3431C10.1995 37.055 8.34107 35.1966 6.05288 35.1966C3.76458 35.1966 1.90625 37.055 1.90625 39.3431C1.90625 41.6321 3.76458 43.4898 6.05288 43.4898Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M39.2287 2.02365C36.9405 2.02365 35.082 3.8821 35.082 6.17029C35.082 8.45927 36.9405 10.3169 39.2287 10.3169C41.517 10.3169 43.3753 8.45927 43.3753 6.17029C43.3753 3.8821 41.517 2.02365 39.2287 2.02365Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M39.2287 43.4898C36.9405 43.4898 35.082 41.6321 35.082 39.3431C35.082 37.055 36.9405 35.1966 39.2287 35.1966C41.517 35.1966 43.3753 37.055 43.3753 39.3431C43.3753 41.6321 41.517 43.4898 39.2287 43.4898Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M15.7324 33.0991V31.05C15.7324 27.2357 18.8293 24.1389 22.6434 24.1389C26.4577 24.1389 29.5544 27.2357 29.5544 31.05V33.0991C27.5764 34.4238 25.1997 35.1965 22.6434 35.1965C20.0871 35.1965 17.7104 34.4238 15.7324 33.0991Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M8.98242 9.1019L13.8431 13.9624"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M8.98242 36.4116L13.8431 31.5519"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M36.3 9.1019L31.4395 13.9624"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M36.3 36.4116L31.4395 31.5519"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
      </svg>
   )
}
